import { render } from "./FCdetails.vue?vue&type=template&id=37fabfdb&scoped=true"
import script from "./FCdetails.vue?vue&type=script&lang=js"
export * from "./FCdetails.vue?vue&type=script&lang=js"

import "./FCdetails.vue?vue&type=style&index=0&id=37fabfdb&lang=scss&scoped=true"
import "./FCdetails.vue?vue&type=style&index=1&id=37fabfdb&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fabfdb"]])

export default __exports__